/**
 * Whether the input looks like a DNS hostname suitable for Investigate / preview (domain workflow).
 * Rejects bare keywords, IPv4/IPv6, and malformed strings.
 */
export function isPlausibleInvestigateDomain(raw) {
  if (raw == null) return false;
  let s = String(raw).trim().toLowerCase();
  if (!s || s.length > 253) return false;
  if (/[\s/]/.test(s)) return false;
  s = s.replace(/^https?:\/\//, '');
  const host = s.split('/')[0].split(':')[0];
  if (!host) return false;
  let h = host.startsWith('www.') ? host.slice(4) : host;
  if (/^(\d{1,3}\.){3}\d{1,3}$/.test(h)) return false;
  if (h.includes(':')) return false;
  if (!h.includes('.')) return false;
  if (!/^[a-z0-9]([a-z0-9.-]*[a-z0-9])?$/.test(h)) return false;
  const labels = h.split('.');
  if (labels.some((l) => !l || l.length > 63)) return false;
  return true;
}
